export enum MapErrorType {
  GOOGLE_MAPS_LOAD_FAILED = "GOOGLE_MAPS_LOAD_FAILED",
  GOOGLE_MAPS_API_ERROR = "GOOGLE_MAPS_API_ERROR",
  MAP_INITIALIZATION_FAILED = "MAP_INITIALIZATION_FAILED",
  MARKER_CREATION_FAILED = "MARKER_CREATION_FAILED",
  API_REQUEST_FAILED = "API_REQUEST_FAILED",
  BOUNDS_FETCH_FAILED = "BOUNDS_FETCH_FAILED",
  NETWORK_ERROR = "NETWORK_ERROR",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export interface MapError {
  type: MapErrorType;
  message: string;
  originalError?: unknown;
  retryable?: boolean;
  context?: Record<string, unknown>;
}

export const createMapError = (
  type: MapErrorType,
  message: string,
  originalError?: unknown,
  context?: Record<string, unknown>,
): MapError => ({
  type,
  message,
  originalError,
  retryable: isRetryableError(type),
  context,
});

const isRetryableError = (type: MapErrorType): boolean => {
  return [
    MapErrorType.API_REQUEST_FAILED,
    MapErrorType.BOUNDS_FETCH_FAILED,
    MapErrorType.NETWORK_ERROR,
  ].includes(type);
};

export const getErrorMessageKey = (type: MapErrorType): string => {
  switch (type) {
    case MapErrorType.GOOGLE_MAPS_LOAD_FAILED:
      return "map.error.googleMapsLoadFailed";
    case MapErrorType.GOOGLE_MAPS_API_ERROR:
      return "map.error.googleMapsApiError";
    case MapErrorType.MAP_INITIALIZATION_FAILED:
      return "map.error.mapInitializationFailed";
    case MapErrorType.MARKER_CREATION_FAILED:
      return "map.error.markerCreationFailed";
    case MapErrorType.API_REQUEST_FAILED:
      return "map.error.apiRequestFailed";
    case MapErrorType.BOUNDS_FETCH_FAILED:
      return "map.error.boundsFetchFailed";
    case MapErrorType.NETWORK_ERROR:
      return "map.error.networkError";
    default:
      return "map.error.unknownError";
  }
};
